const animationOptions = {
  animateSR: "animation-slide-right",
  animateSL: "animation-slide-left",
  animateSU: "animation-slide-up",
  animateSD: "animation-slide-down",
  animateSLR: "animate-slide-left-rotate",
  leftShell: "animate-left-shell",
  rightShell: "animate-right-shell",
  opacity: "animate-opacity",
};

let throttleTimer = false;

const addObserver = (element, options = {}) => {
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.remove("animate");
        entry.target.classList.add("animate.active");
        entry.target.classList.add(animationOptions[element.ariaLabel]);
        observer.unobserve(entry.target);
      }
    });
  }, options); // Passing the options object to the observer
  observer.observe(element);
};

const items = document.querySelectorAll(".animate");
items.forEach((item) => {
  addObserver(item, { rootMargin: "0px 0px -35% 0px" });
});

const technologyCards = document.querySelectorAll(".technology-card-specs");
technologyCards.forEach((card) => {
  card.addEventListener("mouseenter", () => {
    card.classList.add("technology-card--active");
  });

  card.addEventListener("mouseleave", () => {
    card.classList.remove("technology-card--active");
  });
});

const sections = document.querySelectorAll(".section-container");
const leftSideNavIndicators = document.querySelectorAll(".side-nav-indicator");
const openCard = (card) => {
  card.style.innerHeight = "1px";
  card.classList.remove("card-hidden");
  card.classList.add("card-hidden.open");
};

const closeCard = (card) => {
  card.classList.remove("card-hidden.open");
  card.classList.add("card-hidden");
};

const openReadMore = (element, id) => {
  const readMore = document.getElementById(id);
  if (readMore.classList.contains("read-more--active")) {
    element.innerHTML = "Read More";
    readMore.classList.remove("read-more--active");
    readMore.classList.add("read-more--hidden");
    return;
  } else {
    element.innerHTML = "Read Less";
    readMore.classList.remove("read-more--hidden");
    readMore.classList.add("read-more--active");
    return;
  }
};

const accordion = (element, id) => {
  const section = document.getElementById(id);
  const icon = element.querySelector(".accordion-icon");
  if (section.classList.contains("visible--active")) {
    icon.classList.remove("rotated");
    section.classList.remove("visible--active");
    section.classList.add("visible--hidden");
    return;
  } else {
    icon.classList.add("rotated");
    section.classList.remove("visible--hidden");
    section.classList.add("visible--active");
    return;
  }
};

var ambasadoreSwwiper = new Swiper(".ambasadors-swiper", {
  // loop: true,
  autoHeight: true,
  updateOnWindowResize: true,
  spaceBetween: 10,
  slideToClickedSlide: true,
  grabCursor: true,
  simulateTouch: true,
  allowTouchMove: true,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  cssMode: true,
  breakpoints: {
    // when window width is >= 320px
    250: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    450: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    570: {
      slidesPerView: 1.8,
      spaceBetween: 10,
    },
    650: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    959: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    980: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    1300: {
      slidesPerView: 1.8,
      spaceBetween: 10,
    },
    1500: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    1800: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },

    2000: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    2300: {
      slidesPerView: 4.5,
      spaceBetween: 10,
    },
  },
});

var techSwiper = new Swiper(".tech-swiper", {
  autoHeight: true,
  allowTouchMove: true,
  updateOnWindowResize: true,
  spaceBetween: 10,
  slideToClickedSlide: true,
  simulateTouch: true,
  // autoplay: {
  //   delay: 2500,
  // },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  cssMode: true,
});

var imageGallerySwiper = new Swiper(".image-gallery-swiper", {
  allowTouchMove: true,
  initialSlide: 2,
  updateOnWindowResize: true,
  spaceBetween: 10,
  slideToClickedSlide: true,
  simulateTouch: true,
  loop: true,
  // autoplay: {
  //   delay: 2500,
  // },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2.3,
    },
    // 1920: {
    //   slidesPerView: 2.8,
    // },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  cssMode: true,
});

const changeTab = (tabIndex) => {
  let tabButtons = document.getElementsByClassName("tab-btn");
  let tabButtonsArray = Array.from(tabButtons);
  tabButtonsArray.forEach((button) => {
    if (button.classList.contains("tab-btn-active")) {
      button.classList.remove("tab-btn-active");
    }
  });
  let currentButton = tabButtonsArray[tabIndex];
  currentButton.classList.add("tab-btn-active");

  let tabs = document.getElementsByClassName("custom-info-tab");
  let tabsArray = Array.from(tabs);
  tabsArray.forEach((tab) => {
    tab.classList.remove("custom-info-tab-active");
  });
  let selectedTab = document.getElementById(`custom-info-tab-${tabIndex + 1}`);

  selectedTab.classList.add("custom-info-tab-active");
};

const options = {
  rootMargin: "0px",
  threshold: 0.35,
};

const sectionObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const sectionId = entry.target.getAttribute("id");

    if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
      leftSideNavIndicators.forEach((indicator) => {
        if (indicator.ariaLabel === sectionId) {
          indicator.classList.add("side-nav-btn-active");
        } else {
          if (indicator.classList.contains("side-nav-btn-active")) {
            indicator.classList.remove("side-nav-btn-active");
          }
        }
      });
    }
  });
}, options);

sections.forEach((section) => {
  sectionObserver.observe(section);
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 950) {
    changeTab(1);
  } else {
    changeTab(0);
  }
});

const changeProductGalleryImage = (element) => {
  const clickedImageSource = element.src;

  const mainImage = document.getElementById("product-gallery-image");
  mainImage.src = clickedImageSource;
};

let isModalOpen = false;
const openModalVideo = () => {
  isModalOpen = true;
  const modalSection = document.getElementById("video-modal");
  const modalContent = document.getElementById("video-modal-content");
  const height = window.innerHeight;
  modalContent.style.marginTop = `${height}px`;

  modalSection.style.display = "block";
  modalSection.style.visibility = "visible";
};

const closeModalVideo = () => {
  const modalSection = document.getElementById("video-modal");
  modalSection.style.display = "none";
  modalSection.style.visibility = "hidden";
};

window.addEventListener("scroll", () => {
  if (isModalOpen === true) {
    const modalContent = document.getElementById("video-modal-content");
    const height = window.innerHeight;
    modalContent.style.marginTop = `${height}px`;
  }
});

let currentAspireModel = "";

const models = {
  "aspire-1": {
    title: "Aspire 1",
    description: `Our decades of combined experience in performance monitoring distilled into its purest form: a single-driver in- ear monitor. Aspire 1’s full-range dynamic driver is precisely tuned using multiple Helmholtz Resonators, integrated into its 3D-printed housing, to deliver a bass-forward interpretation of our balanced sound signature.`,
    id: "48063148097769",
    subtitle: "One Driver In-Ear Monitors",
    price: "$349.00",
    assets: [
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/PLP-Aspire-Series_Aspire1.webp?v=1736915152",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-F_Aspire-1_7741b57f-351d-4892-9a42-8c8c19f3505d.webp?v=1737087744",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-B_Aspire-1.webp?v=1736484917",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Included-Items-Aspire1.webp?v=1736915152",
    ],
    tech: {
      "wave-guide": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/WHT_HHR_-_Aspire_1_2.webp?v=1737004398",
        text: `3D Printed micro-cavities operate by forcing air in and out, causing the air inside to resonate at a specific frequency. By precisely determining the dimensions of the cavity and its neck, we can target a very narrow resonant frequency to amplify or diminish.`,
      },

      "sound-signature": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_1_Graph_Desktop_2.svg?v=1737399361",
        text: "",
      },
      "sound-signature-mobile": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_1_Graph_Mobile_2.svg?v=1737399361",
        text: " ",
      },
    },
    specs: {
      color: "Black/Silver",
      frequency: "20Hz – 18kHz",
      impedance: "30 Ω @ 1kHz",
      sensitivity: "106 dB @ 1kHz @1mw",
      isolation: "-20 dB",
      driver: ["Full Range Dynamic Driver"],
    },
  },
  "aspire-2": {
    title: "Aspire 2",
    description: `A dual-driver system with a two-way crossover provides increased flexibility in tuning. By leveraging the unique characteristics of both dynamic and balanced armature drivers, Aspire 2 delivers focused low-end impact alongside detailed mids and highs. Additionally, its integrated Helmholtz Resonator technology helps achieve a forward low-end presentation with an elevated high-frequency response—without harshness.`,
    id: "48063148130537",
    subtitle: "Two Driver In-Ear Monitors",
    price: "$499.00",
    assets: [
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/PLP-Aspire-Series_Aspire2.webp?v=1736915152",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-F_Aspire-2_16edc2dd-b030-4f2e-ac6b-b0b13e41b99e.webp?v=1737087746",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-B_Aspire-2.webp?v=1736484917",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Included-Items-Aspire2.webp?v=1736915152",
    ],
    tech: {
      "wave-guide": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/WHT_HHR_-_Aspire_1_2.webp?v=1737004398",
        text: `3D Printed micro-cavities operate by forcing air in and out, causing the air inside to resonate at a specific frequency. By precisely determining the dimensions of the cavity and its neck, we can target a very narrow resonant frequency to amplify or diminish.`,
      },

      "sound-signature": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_2_Graph_Desktop_2.svg?v=1737399361",
        text: "",
      },
      "sound-signature-mobile": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_2_Graph_Mobile_2.svg?v=1737399361",
      },
    },
    specs: {
      color: "Black/Grey",
      frequency: "20Hz – 18kHz",
      impedance: "13 Ω @ 1kHz",
      sensitivity: "103 dB @ 1kHz @1mw",
      isolation: "-20 dB",
      driver: ["1 Low Dynamic Driver", "1 High / Mid Balanced Armature Driver"],
    },
  },
  "aspire-3": {
    title: "Aspire 3",
    description: `A carefully refined three-driver design that strikes the perfect balance between energy and precision. Its hybrid configuration features a dynamic driver for lows, a balanced armature for mids, and another balanced armature for highs. While the bass remains rich and robust, the mids take center stage—adding extra body to vocals and instruments. Aspire 3 also integrates a custom high-frequency waveguide, further shaping its balanced frequency response to ensure clarity and articulation where it matters most.`,
    id: "48063148163305",
    subtitle: "Three Driver In-Ear Monitors",
    price: "$649.00",
    assets: [
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/PLP-Aspire-Series_Aspire3.webp?v=1736915152",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-F_Aspire-3_5ff1ca95-b64e-4ce4-8c44-f228fb1d737e.webp?v=1737087744",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-B_Aspire-3.webp?v=1736484917",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Included-Items-Aspire3.webp?v=1736915152",
    ],
    tech: {
      "wave-guide": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/WHT_Waveguide_-_Aspire_3.webp?v=1737004398",
        text: `Custom designed acoustic structure integrated onto the high-frequency balanced armature driver. Unique in its shape and implementation, this waveguide increases the driver's efficiency by directing and focusing its energy for a crisp and clear sound.`,
      },

      "sound-signature": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_3_Graph_Desktop_2.svg?v=1737399361",
        text: "",
      },
      "sound-signature-mobile": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_3_Graph_Mobile_2.svg?v=1737399361",
        text: "",
      },
    },
    specs: {
      color: "Black/Red",
      frequency: "20Hz – 18kHz",
      impedance: "12 Ω @ 1kHz",
      sensitivity: "107 dB @ 1kHz @1mw",
      isolation: "-20 dB",
      driver: [
        "1 Low Dynamic Driver",
        "1 Mid Balanced Armature Driver",
        "1 High Balanced Armature Driver",
      ],
    },
  },
  "aspire-4": {
    title: "Aspire 4",
    description: `The quad-driver flagship of the Aspire series delivers class-leading performance and technology for musicians who demand ultimate intelligibility in their monitoring. Aspire 4 features a sophisticated hybrid- driver setup—one dynamic driver for deep, controlled bass, two balanced armature drivers for lush mids, and one balanced armature driver for crisp highs. Its balanced tuning includes a subtle upper-midrange boost, ensuring instruments and vocals cut through the mix with clarity and precision— both on stage and in the studio.`,
    id: "48063148065001",
    subtitle: "Four Driver In-Ear Monitors",
    price: "$799.00",
    assets: [
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/PLP-Aspire-Series_Aspire4.webp?v=1737485162",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-F_Aspire-4_3c6962a0-4eb3-40f2-8524-7714305ae1c0.webp?v=1737087743",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/FLT-B_Aspire-4.webp?v=1736484917",
      "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Included-Items-Aspire4.webp?v=1736915152",
    ],
    tech: {
      "wave-guide": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/WHT_Waveguide_-_Aspire_4.webp?v=1737004398",
        text: `Custom designed acoustic structure integrated onto the high-frequency balanced armature driver. Unique in its shape and implementation, this waveguide increases the driver's efficiency by directing and focusing its energy for a crisp and clear sound.`,
      },

      "sound-signature": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_4_Graph_Desktop_2.svg?v=1737399361",
        text: "",
      },
      "sound-signature-mobile": {
        img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Aspire_4_Graph_Mobile_2.svg?v=1737399361",
        text: "",
      },
    },
    specs: {
      color: "Black",
      frequency: "20Hz – 18kHz",
      impedance: "11Ω @ 1kHz",
      sensitivity: "104dB @ 1kHz @1mw",
      isolation: "-20 dB",
      driver: [
        "1 Low Dynamic Driver",
        "2 Mid Balanced Armature Drivers",
        "1 High Balanced Armature Driver",
      ],
    },
  },
};

const modelUI = {
  modelCards: document.querySelectorAll(".model-card"),
  galleryThumbs: document.querySelectorAll(".product-img"),
  galleryMain: document.getElementById("product-gallery-image"),
  cartButtons: document.querySelectorAll(".add-cart"),
  driverTargets: document.querySelectorAll(".active-model-driver"),
  aspireModelBtn: document.querySelectorAll(".aspire-model-btn"),
  textTargets: {
    title: document.querySelectorAll(".active-model-title"),
    subtitle: document.querySelectorAll(".active-model-subtitle"),
    price: document.querySelectorAll(".active-model-price"),
    color: document.querySelectorAll(".active-model-color"),
    frequency: document.querySelectorAll(".active-model-frequency"),
    impedance: document.querySelectorAll(".active-model-impedance"),
    sensitivity: document.querySelectorAll(".active-model-sensitivity"),
    isolation: document.querySelectorAll(".active-model-isolation"),
    description: document.querySelectorAll(".active-model-description"),
  },
  waveGuides: document.querySelectorAll(".wave-guide"),
  waveGuideTech: document.querySelectorAll("[data-tech='wave-guide']"),
  soundDesktop: document.querySelectorAll(".sound-signature"),
  soundMobile: document.querySelectorAll(".sound-signature-mobile"),
};

function setActiveModelInformation(field, type) {
  const nodes = modelUI.textTargets[type];
  const value =
    models[currentAspireModel][type] ??
    models[currentAspireModel].specs?.[type] ??
    "";

  if (!nodes) return;

  nodes.forEach((node) => {
    node.textContent = value;
  });
}

function setImages(targetField, imageType) {
  let nodes;

  if (targetField === "wave-guide") {
    nodes = modelUI.waveGuides;
  } else if (targetField === "sound-signature") {
    nodes = modelUI.soundDesktop;
  } else if (targetField === "sound-signature-mobile") {
    nodes = modelUI.soundMobile;
  } else {
    console.warn(`Unknown image field: ${targetField}`);
    return;
  }

  const src = models[currentAspireModel]?.tech?.[imageType].img ?? "";

  nodes.forEach((node) => {
    node.src = src;
  });
}

const setSpecs = (model) => {
  const specs = models[model].specs;
  Object.keys(specs).forEach(function (key, index) {
    const elements = document.getElementsByClassName(`active-model-${key}`);
    if (key === "driver") {
      Array.from(elements).forEach((activeElement) => {
        const driver = specs.driver;
        const driverElements = driver.map((spec) => {
          const tag = document.createElement("p");
          tag.className = "margin-0";
          tag.textContent = spec;
          return tag;
        });
        activeElement.innerHTML = "";
        activeElement.append(...driverElements);
      });
    } else {
      Array.from(elements).forEach((activeElement) => {
        activeElement.innerHTML = specs[key];
      });
    }
  });
};

let currentSelected = null;
let prevBtns = "aspire-1";
let newBtns = null;

function selectActive(modelKey, mobile = false) {
  const modelData = models[modelKey];
  const newCartLink = `/cart/add?id=${modelData.id}`;

  //  Reset all model cards
  modelUI.modelCards.forEach((card) => {
    card.classList.remove("model-card-active");
    card.classList.add("not-selected");
  });

  // Update gallery images
  modelUI.galleryThumbs.forEach((img, index) => {
    img.src = modelData.assets[index] || "";
  });
  if (modelUI.galleryMain) {
    modelUI.galleryMain.src = modelData.assets[0] || "";
  }

  modelUI.textTargets.description.forEach((tag) => {
    tag.innerHTML = modelData.description;
  });
  // Activate selected card
  const selectedCard = document.getElementById(modelKey);
  if (selectedCard && selectedCard.parentNode) {
    selectedCard.parentNode.classList.add("model-card-active");
  }

  modelUI.waveGuideTech.forEach((element) => {
    element.innerHTML = modelData?.tech?.["wave-guide"].text;
  });
  console.log(modelUI.aspireModelBtn);
  modelUI.aspireModelBtn.forEach((btn) => {
    if (btn.dataset.model === currentAspireModel) {
      btn.classList.add("not-selected");
    }
    if (btn.dataset.model === modelKey) {
      btn.classList.remove("not-selected");
    }
  });

  //  Set current model globally
  currentAspireModel = modelKey;

  //  Update top block (title, subtitle, price)
  setActiveModelInformation("active-model-title", "title");
  setActiveModelInformation("active-model-subtitle", "subtitle");
  setActiveModelInformation("active-model-price", "price");

  //  Update tech images
  setImages("wave-guide", "wave-guide");

  // 7. Show/hide lid section
  const lidTechElements = document.querySelectorAll(".lid-tech");
  lidTechElements.forEach((tag) => {
    if (modelKey === "aspire-1") {
      tag.classList.add("hidden");
    } else {
      tag.classList.remove("hidden");
    }
  });

  // 8. Update sound signature images
  if (mobile) {
    setImages("sound-signature", "sound-signature-mobile");
  } else {
    setImages("sound-signature", "sound-signature");
  }

  // 9. Update specs
  setSpecs(modelKey);

  // 10. Update "Order Now" buttons
  modelUI.cartButtons.forEach((btn) => {
    btn.classList.remove("disabled");
    btn.innerHTML = "Order Now";
    btn.href = newCartLink;
  });

}

const wrappers = document.querySelectorAll(".image-wrapper");

const smOnModelClick = (id) => {
  prevBtns = newBtns;
  newBtns = id;

  const aspireBtn = document.querySelectorAll(".aspire-btn");

  aspireBtn.forEach((btn) => {
    if (btn.dataset.model === id) {
      btn.className += " pill-btn-active";
    }
  });

  if (prevBtns) {
    const oldActive = document.querySelectorAll(".aspire-btn");
    oldActive.forEach((btn) => {
      if (btn.dataset.model === prevBtns)
        btn.classList.remove("pill-btn-active");
    });
  }

  if (currentSelected) {
    currentSelected.classList.remove("selected");
  }
  wrappers.forEach((wrapper) => {
    if (wrapper.dataset.model === id) {
      wrapper.classList.add("selected");
      currentSelected = wrapper;

      // Scroll the selected image into the center of the container
      wrapper.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  });

  selectActive(id, true);
};

addEventListener("load", (event) => {
  smOnModelClick("aspire-1");
});

const updateOrderNowBtnModel = (btn) => {
  const prev = document.getElementById(`order-now-btn-${currentAspireModel}`);
  prev.classList.add("not-selected");
  btn.classList.remove("not-selected");
};

function scrollToSection(sectionName) {
  const section = document.getElementById(sectionName);
  console.log(section);
  if (section) {
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    console.warn(`Section with name "${sectionName}" not found.`);
  }
}
